import { createStore } from 'vuex'

let browserlanguage = (
  (navigator.language ? navigator.language : navigator.userLanguage) || "en"
).toLowerCase();
let language = browserlanguage.split("-")[0]

if (language == 'zh' || language == 'en' || language == 'ko' || language == 'ja' || language == 'ru' || language == 'vn' || language == 'es' || language == 'fr' || language == 'de' || language == 'tr') {
  language = language
} else {
  language = 'en'
}

export default createStore({
  state: {
    lan: localStorage.getItem('lan') || language || 'en',
    path: localStorage.getItem('path') || '/',
    config: null,
    connectWallet: ''
  },
  mutations: {
    changeLan(state, data) {
      state.lan = data
    },
    changePath(state, data) {
      state.path = data
    },
    setConfig(state, data) {
      state.config = data
    },
    setConnectWallet(state, data) {
      state.connectWallet = data
    },
  }
})